import React, { useRef, useState } from "react";
import {
    Box, Button, Card,
    CardContent,
    CircularProgress,
    IconButton,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import { useAuthContext } from "../../contexts";
import { VForm, useVForm, VTextField } from "../../forms";
import { IDetalheUsuarioCadastro } from "../../services/api/usuario/UsuarioService";
import { RadioGroup } from "../radio-grupo/radioGrupo";
import { CheckBox } from "../checkbox/CheckBox";
import { DialogMensagem, IDadosModal } from "../modal/DialogMensagem";
import { Loading } from "../loading/Loading";
import parse from "date-fns/parse";
import { addYears, isDate } from "date-fns";
import { maskCNPJEvent, maskCPFEvent, UtilidadeService } from "../../services/api/utilidades/UtilidadesService";
import Grid from '@mui/material/Grid2';
import logo from "../../../img/logo_sombra.png";
import { CalendarMonth, Opacity, Padding } from "@mui/icons-material";
import { VTextMaskCPF } from "../../forms/VTextMaskCPF";

const sexoItens = [
    { codigo: 1, label: 'Masculino' },
    { codigo: 2, label: 'Feminino' },
    { codigo: 3, label: 'Outros' }
]


function parseDateString(originalValue: any) {
    return isDate(originalValue)
        ? originalValue  // this make sure that a value is provided
        : parse(originalValue, "yyyy-MM-dd", new Date());
}
// const formValidationSchema: Yup.Schema<IDetalheUsuarioCadastro> = Yup.object().shape({
//     //nome: yup.string().matches(/^[A-Za-z0-9]{2,}( [A-Za-z0-9]+)*?( [A-Za-z0-9]{2,}){1,}$/i, "Favor informar o nome completo").required().min(3, "O campo deve ter mais que 3 caracteres"),
//     nome: Yup.string().matches(/^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/, "Favor informar o nome completo").required().min(3, "O campo deve ter mais que 3 caracteres"),
//     //email: yup.string().email.matches(/^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i, "Favor informar um e-mail válido!").required().email(),
//     email: Yup.string().required("O campo e-mail é obrigatório").email("E-mail inválido"),
//     login: Yup.string().required().min(4, "O campo deve ter mais que 4 caracteres"),
//     senha: Yup.string().required().min(3, "O campo deve ter mais que 3 caracteres"),
//     confirmarSenha: Yup.string().required("Campo é obrigatório").oneOf([Yup.ref("senha")], "Senha não confere"),
//     dtNascimento: Yup.date(),
//     sexo: Yup.number().typeError("Favor selecionar o campo sexo").required("Favor informar o campo sexo"),
//     ativo: Yup.boolean().default(true),
//     administrador: Yup.boolean().default(false),
//     codTema: Yup.number().default(2)

// });


type Props = {
    children?: React.ReactNode,
    handleChange: any
};

export const Cadastrar: React.FC<Props> = ({ handleChange, children }) => {
    const { formRef } = useVForm();
    const { handleCadastrar } = useAuthContext();
    const [isLoading, setIsLoading] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(true);
    const theme = useTheme();
    const [cadastroError, setCadastroError] = useState("");
    const [dataNascimento, setDataNascimento] = useState("");
    const [cpfCnpj, setCpfCnpj] = useState("")
    const [mensagem, setMensagem] = useState("");
    const [isMensagemError, setIsMensagemError] = useState(false);
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [possuiErrors, setPossuiErrors] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });
    const [errors, setErrors] = useState({
        error: false,
        nomeRef: "",
        emailRef: "",
        cpfCnpjRef: "",
        loginRef: "",
        senhaRef: "",
        confirmarSenhaRef: "",
        dtNascimentoRef: "",
        sexoRef: "",
        mensagemErro: ""
    });

    const handleSubmit = async (dados: IDetalheUsuarioCadastro) => {

        setRemoveLoading(false);
        setIsLoading(true);

        if (dataNascimento !== "") {
            dados.dtNascimento = dataNascimento;
        }

        let possuiErro = await validacaoDosValores(dados);
        if (possuiErro) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Existe campo obrigatório não preenchido ou valor inválido. Favor verificar!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            setRemoveLoading(true);
            return;
        }
        else {
            await handleCadastrar(dados)
                .then((response) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Cadastro realizado com sucesso!",
                        display: "none",
                        titulo: "Sucesso"
                    });
                    //setRedirecionar("0");
                    setTimeout(() => handleChange("event", 0), 3000);

                }).catch((errors) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setIsMensagemError(true);  
                    console.log(errors);                  
                    if (!errors.response.data.processado) {
                        setMensagem(errors.response.data.mensagem);
                    }
                    else{
                        setMensagem("Não foi possível realizar o cadastro, tente novamente mais tarde!");
                    }
                });
        }
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
    };

    async function validacaoDosValores(valores: IDetalheUsuarioCadastro) {

        let objError = await verificarCamposObrigatorios(valores);
        setErrors(objError);
        return objError.error;
    }

    const nomeRef = useRef<null | HTMLElement>(null);
    const emailRef = useRef<null | HTMLElement>(null);
    const loginRef = useRef<null | HTMLElement>(null);
    const cpfCnpjRef = useRef<null | HTMLElement>(null);
    const senhaRef = useRef<null | HTMLElement>(null);
    const confirmarSenhaRef = useRef<null | HTMLElement>(null);
    const dtNascimentoRef = useRef<null | HTMLElement>(null);
    const sexoRef = useRef<null | HTMLElement>(null);

    async function verificarCamposObrigatorios(dados: IDetalheUsuarioCadastro) {
        const errors: any = {};
        let err = false;

        if (dados.nome === "" || dados.nome === undefined) {
            nomeRef.current?.focus();
            errors.nomeRef = "Campo obrigatório";
            errors.error = err = true;

        };
        if (dados.nome.length < 3) {
            nomeRef.current?.focus();
            errors.nomeRef = "Favor informar o nome completo";
            errors.error = err = true;

        };

        if (!dados.nome.match(/^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/)) {
            nomeRef.current?.focus();
            errors.nomeRef = "Favor informar o nome completo";
            errors.error = err = true;
        }
        if (dados.email === "" || dados.email === undefined) {

            emailRef.current?.focus();
            errors.emailRef = "Campo obrigatório";
            errors.error = err = true;

        }
        if (!dados.email.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/)) {
            emailRef.current?.focus();
            errors.emailRef = "E-mail inválido!";
            errors.error = err = true;
        };
        if (dados.login === "" || dados.login === undefined) {
            loginRef.current?.focus();
            errors.loginRef = "Campo obrigatório";
            errors.error = err = true;

        };
        if (dados.cgcCnpj === "" || dados.cgcCnpj === undefined) {
            cpfCnpjRef.current?.focus();
            errors.cpfCnpjRef = "Campo obrigatório";
            errors.error = err = true;

        };
         if (dados.cgcCnpj.length < 14 ) {
            cpfCnpjRef.current?.focus();
            errors.cpfCnpjRef = "Campo inválido";
            errors.error = err = true;

        };
        if (dados.login.length < 4) {
            loginRef.current?.focus();
            errors.loginRef = "O campo deve ter pelo menos 4 caracteres";
            errors.error = err = true;
        };

        if (dados.senha === "" || dados.senha === undefined) {
            senhaRef.current?.focus();
            errors.senhaRef = "Campo obrigatório";
            errors.error = err = true;
        };
        if (dados.senha.length < 6) {
            senhaRef.current?.focus();
            errors.senhaRef = "O campo deve ter pelo menos 6 caracteres";
            errors.error = err = true;
        };
        if (dados.confirmarSenha === "" || dados.confirmarSenha === undefined) {

            confirmarSenhaRef.current?.focus();
            errors.confirmarSenhaRef = "Campo obrigatório";
            errors.error = err = true;
        };
        if (dados.confirmarSenha !== dados.senha) {

            confirmarSenhaRef.current?.focus();
            errors.confirmarSenhaRef = "A senha não confere!";
            errors.error = err = true;
        };

        if (dados.sexo <= 0 || dados.sexo === undefined) {
            sexoRef.current?.focus();
            errors.sexoRef = "Campo obrigatório!";
            errors.error = err = true;
        }
        if (dados.dtNascimento === undefined) {
            dtNascimentoRef.current?.focus();
            errors.dtNascimentoRef = "Campo obrigatório!";
            errors.error = err = true;
        }
        else {

            let dataNasc = Date.parse(dados.dtNascimento.toString());
            let dataLimite = Date.parse(addYears(new Date(), -18).toISOString().replaceAll("/", "-").slice(0, 10));
            if (dataNasc >= Date.parse(new Date().toISOString().replaceAll("/", "-").slice(0, 10))) {
                dtNascimentoRef.current?.focus();
                errors.dtNascimentoRef = "Data inválida!";
                errors.error = err = true;
            }

            if (dataNasc >= dataLimite) {
                dtNascimentoRef.current?.focus();
                errors.dtNascimentoRef = "A idade mínima para se cadastrar no Fantasy são 18 anos!";
                errors.error = err = true;
            }
        }
        setPossuiErrors(err);
        return errors;
    };

    const sectionStyle = {
        minWidth: "180px",
        backgroundImage:
            `url(${logo}) `,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: 'bottom',
        alignItems: "baseline",
        minHeight: "300px",

    };

    function showDatePicker() {
        // @ts-ignore
        document.querySelector("input[type=date]").showPicker();
    }

    return (
        <Box display="flex" alignItems="center" justifyContent="center"
            style={{ padding: 0 }}

        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSubmit}>
                <Card sx={{ boxShadow: "none", paddingTop: "0" }}>
                    <CardContent sx={{ paddingTop: "0" }} >
                        <Box display="flex" flexDirection="column" paddingTop={0} style={sectionStyle}>
                            <Grid container size={12} direction="row" spacing={UtilidadeService.isMobile() ? 2 : 1}>
                                <Grid size={{ xs: 12, sm: 12 }} >
                                    <VTextField
                                        required
                                        fullWidth
                                        placeholder="Nome"
                                        name="nome"
                                        size={"small"}
                                        variant="standard"
                                        disabled={isLoading}
                                        label="Nome Completo"
                                        ref={nomeRef as any}
                                        onChange={(e) => {
                                            setErrors({ ...errors, nomeRef: "" });
                                        }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, fontWeight: "bold" }}
                                    />
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="12px">
                                        {errors.nomeRef && <span style={{ fontSize: UtilidadeService.isMobile() ? "10px" : "13px", color: "red" }}>{errors.nomeRef}</span>}
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                    <TextField
                                        fullWidth
                                        required
                                        variant="standard"
                                        slotProps={{
                                            inputLabel: {
                                                shrink: true,
                                                style: {
                                                    fontSize: UtilidadeService.isMobile() ? 14 : 16
                                                }
                                            }
                                        }}
                                        type="date"
                                        name="dtNascimento"
                                        value={dataNascimento}
                                        onChange={(e) => setDataNascimento(e.target.value)}
                                        disabled={isLoading}
                                        size={"small"}
                                        label="Data Nascimento"
                                        ref={dtNascimentoRef as any}
                                        style={{ colorScheme: "auto" }}
                                        sx={{
                                            "::-webkit-calendar-picker-indicator": {
                                                cursor: "pointer",
                                                borderRadius: "4px",
                                                marginRight: "2px",
                                                opacity: "1",
                                                colorScheme: "dark"
                                            }
                                        }}
                                    >
                                        <CalendarMonth onClick={showDatePicker} style={{ bottom: "5px", right: "5px" }} />
                                    </TextField>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 6 }} display={"none"}>
                                    <CheckBox
                                        isExternalLoading={true}
                                        name="ativo"
                                        label="Ativo"
                                        checked={true}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14 }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 12 }} marginTop="-10px" >
                                    {errors.dtNascimentoRef && <span style={{ fontSize: UtilidadeService.isMobile() ? "10px" : "13px", color: "red" }}>{errors.dtNascimentoRef}</span>}
                                </Grid>
                            </Grid>
                            <Grid container direction="row" spacing={UtilidadeService.isMobile() ? 2 : 1} style={{ padding: 0 }}>
                                <Grid size={{ xs: 12, sm: 12 }} style={{ paddingTop: 0 }}>
                                    <VTextField
                                        fullWidth
                                        required
                                        variant="standard"
                                        placeholder="E-mail"
                                        name="email"
                                        size={"small"}
                                        disabled={isLoading}
                                        label="E-mail"
                                        ref={emailRef as any}
                                        onChange={(e) => {
                                            setErrors({ ...errors, emailRef: "" });
                                        }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14 }}
                                    />
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="12px">
                                        {errors.emailRef && <span style={{ fontSize: UtilidadeService.isMobile() ? "10px" : "13px", color: "red" }}>{errors.emailRef}</span>}
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                    <VTextMaskCPF
                                        label="CPF/CNPJ"
                                        required
                                        fullWidth                                        
                                        ref={cpfCnpjRef as any}
                                        //error={!!cpfCnpjRef}
                                        //helperText={cpfCnpjRef}
                                        size={"small"}
                                        color="primary"
                                        variant="standard"
                                        name="cgcCnpj"
                                        disabled={isLoading}
                                        placeholder="CPF/CNPJ"
                                        value={cpfCnpj}
                                        onChange={(e: any) => {                                           
                                            setErrors({ ...errors, cpfCnpjRef: "" })
                                        }}
                                        slotProps={{
                                            htmlInput: {
                                                maxLength: 9
                                            },
                                            inputLabel: {
                                                shrink: true,
                                            },
                                        }} />
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="12px">
                                        {errors.cpfCnpjRef && <span style={{ fontSize: UtilidadeService.isMobile() ? "10px" : "13px", color: "red" }}>{errors.cpfCnpjRef}</span>}
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12 }}>
                                    <RadioGroup
                                        isExternalLoading={isLoading}
                                        items={sexoItens}
                                        name="sexo"
                                        label="Sexo"
                                        ref={sexoRef as any}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14 }}

                                    />
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                        {errors.sexoRef && <span style={{ fontSize: UtilidadeService.isMobile() ? "10px" : "13px", color: "red" }}>{errors.sexoRef}</span>}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" spacing={1}>
                                <Grid size={{ xs: 12, sm: 12 }} style={{ paddingTop: 0 }}>
                                    <VTextField
                                        required
                                        fullWidth
                                        variant="standard"
                                        placeholder="Login"
                                        name="login"
                                        disabled={isLoading}
                                        label="Login"
                                        ref={loginRef as any}
                                        onChange={(e) => {
                                            setErrors({ ...errors, loginRef: "" });
                                        }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14 }}
                                    />
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="12px">
                                        {errors.loginRef && <span style={{ fontSize: UtilidadeService.isMobile() ? "10px" : "13px", color: "red" }}>{errors.loginRef}</span>}
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                    <VTextField
                                        required
                                        fullWidth
                                        variant="standard"
                                        placeholder="Senha"
                                        type="password"
                                        name="senha"
                                        disabled={isLoading}
                                        label="Senha"
                                        ref={senhaRef as any}
                                        onChange={(e) => {
                                            setErrors({ ...errors, senhaRef: "" });
                                        }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14 }}
                                    />
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="12px">
                                        {errors.senhaRef && <span style={{ fontSize: UtilidadeService.isMobile() ? "10px" : "13px", color: "red" }}>{errors.senhaRef}</span>}
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                    <VTextField
                                        required
                                        fullWidth
                                        variant="standard"
                                        placeholder="Confirmar Senha"
                                        type="password"
                                        name="confirmarSenha"
                                        disabled={isLoading}
                                        label="Confirmar Senha"
                                        ref={confirmarSenhaRef as any}
                                        onChange={(e) => {
                                            setErrors({ ...errors, confirmarSenhaRef: "" });
                                        }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14 }}
                                    />
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="12px">
                                        {errors.confirmarSenhaRef && <span style={{ fontSize: UtilidadeService.isMobile() ? "10px" : "13px", color: "red" }}>{errors.confirmarSenhaRef}</span>}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </CardContent>
                    <CardContent>
                        {!removeLoading && <Loading />}
                        <Box width="100%" display="flex" alignItems="center" justifyContent="center" paddingTop={0}>
                            <Button
                                type="submit"
                                disabled={!removeLoading}
                                variant="contained"
                                endIcon={!removeLoading ? <CircularProgress size={20} variant="indeterminate" color="inherit" /> : null}
                            >
                                Cadastrar
                            </Button>

                        </Box>
                        <Grid container padding={1} display="flex" alignItems="center" justifyContent="center">
                            <Typography sx={{ color: isMensagemError ? '#ee8585' : 'auto' }}>{!isLoading && mensagem}</Typography>
                        </Grid>
                    </CardContent>
                </Card>
            </VForm>
        </Box >
    );
}


